import isLayerTypeAuthorized from './isLayerTypeAuthorized';
import {uniqBy, orderBy, find} from 'lodash';

interface CleanUserLayersInput {
    layerTypes: {[key: string]: LayerType};
    isLayered: boolean | undefined;
    userLayers: UserLayer[];
    defaultUserLayers: UserLayer[];
    user: User | undefined;
}

export default function cleanUserLayers(
    {layerTypes, isLayered, userLayers, defaultUserLayers, user}: CleanUserLayersInput
) {
    userLayers = uniqBy(userLayers, 'layer.type');

    // Ensure all layers have a corresponding layerType
    // Ensure user is authorized to view all the selected layerTypes
    userLayers = userLayers.filter(({layer}) => {
        const layerType = layerTypes[layer.type];
        return layerType && isLayerTypeAuthorized(layerType, user);
    });

    // Ensure there is at least one selected layer
    userLayers = userLayers.length === 0 ?
        defaultUserLayers.slice(0, 1) :
        userLayers;

    // Ensure there is at least one visible layer
    if (!find(userLayers, ({isVisible}) => isVisible)) {
        userLayers = uniqBy([
            find(defaultUserLayers, ({isVisible}) => isVisible)!,
            ...userLayers
        ], 'layer.type');
    }

    // Ensure there is at most one visible layer in non-layered mode
    // When "isLayered" is `undefined` it is loading and we must not modify the active layers.
    if (isLayered === false) {
        let isFirstVisibleLayer = true;
        userLayers = userLayers.map(selectedLayer => {
            if (selectedLayer.isVisible && isFirstVisibleLayer) {
                isFirstVisibleLayer = false;
                return selectedLayer;
            } else {
                return {...selectedLayer, isVisible: false};
            }
        });
    }

    // Preserve visual ordering when switching between isLayered settings
    if (isLayered === true) {
        userLayers = orderBy(userLayers, 'isVisible');
    }

    return userLayers;

}
